import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Router, Route, IndexRoute } from 'react-router';
import Orders from '@app/modules/orders/containers/Orders';
import requireAuthentication from '@app/auth/requireAuthentication';
import NotFoundPage from './containers/NotFoundPage';
import App from './containers/App';

const context = require.context('./modules', true, /routes.js/);
const modulesRoutes = context.keys().map(module => context(module).default);

const propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const Root = ({ store, history }) => {
  const modules = modulesRoutes.filter(Boolean).map(addArrayKeyForReact);

  return (
    <Provider store={store}>
      <Router key={Math.random()} history={history}>
        <Route path="/" component={App}>
          {modules}
          <IndexRoute
            components={{ content: requireAuthentication(Orders) }}
            title={<FormattedMessage id="orders" defaultMessage="Orders" />}
          />
          <Route path="*" components={{ content: NotFoundPage }} />
        </Route>
      </Router>
    </Provider>
  );
};

function addArrayKeyForReact(module) {
  const {
    key,
    props: { path },
  } = module;

  return {
    ...module,
    key: key || path,
  };
}

Root.propTypes = propTypes;

export default Root;



// WEBPACK FOOTER //
// ./src/Root.jsx